'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      shape = _baseTheme$vstui.shape,
      cloud3 = color.cloud.getShade(3);
  return (0, _themes.createComponentTheme)(baseTheme, {
    Popover_backgroundColor: color.surface,
    Popover_borderColor: cloud3,
    Popover_borderRadius: shape.borderRadius,
    Popover_borderStyle: 'none',
    Popover_borderWidth: shape.borderWidth,
    Popover_boxShadow: '0 1px 3px rgba(0, 0, 0, 0.5)'
  });
};

exports.default = componentTheme;